import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { getChatActions } from '@/lib/chat-actions/chat-actions-bindings';
import { mapAudienceProfileToSpark } from '@/entities/persona-spark';
import { createOpportunitySummary } from '@/entities/opportunity';
import type { SocialOpportunityItem } from '@inference.engine/widgets/web';
import { SPECIAL_AGENT_IDS } from '@/entities/agent';
import type { InterviewMetadata, AudienceProfile } from './useStartInterview.types';

export const useStartInterview = () => {
  const navigate = useNavigate();

  const startInterview = useCallback(
    (
      personaId: string,
      promptOverride?: string,
      audienceProfile?: AudienceProfile,
      opportunity?: SocialOpportunityItem,
    ) => {
      const metadata: InterviewMetadata = {
        ...(audienceProfile && { personaSpark: mapAudienceProfileToSpark(audienceProfile) }),
        ...(opportunity && { opportunitySummary: createOpportunitySummary(opportunity) }),
      };

      const hasContext = audienceProfile && opportunity;

      const { launchAgentWithWidget, sendOrCreateChat } = getChatActions();

      if (hasContext && promptOverride) {
        void sendOrCreateChat(navigate, {
          agentId: SPECIAL_AGENT_IDS.AUDIENCE_FLOW,
          prompt: promptOverride,
          inputs: {
            selectedPersonaId: personaId,
            promptOverride,
            metadata,
          },
        });
        return;
      }

      launchAgentWithWidget(navigate, SPECIAL_AGENT_IDS.AUDIENCE_FLOW, {
        selectedPersonaId: personaId,
        ...(promptOverride && { promptOverride }),
        ...(Object.keys(metadata).length > 0 && { metadata }),
      });
    },
    [navigate],
  );

  return { startInterview };
};
